<template>
    <div v-if="isOpen" class="reatlas-detail-panel">
        <!-- Overlay -->
        <div class="reatlas-detail-panel__overlay" @click="$emit('close')"></div>

        <!-- Panel -->
        <div class="reatlas-detail-panel__container">
            <!-- Loading state -->
            <div v-if="loading" class="reatlas-detail-panel__loading">
                <button class="reatlas-detail-panel__close-btn" @click="$emit('close')" aria-label="Close panel">&#x2715;</button>
                <div class="reatlas-detail-panel__loading-spinner"></div>
                <p class="reatlas-detail-panel__loading-text">Loading site...</p>
            </div>

            <site
                v-else-if="Object.keys(selectedSite).length"
                :data="selectedSite"
                @reatlas-close-right-panel="$emit('close')"
                from-reatlas
            />
            <comp-detail
                v-if="layout == 'projects' && Object.keys(selectedComp).length"
                :project-data="projectData"
                :comp-data="selectedComp"
                :from-reatlas="true"
                @reatlas-close-right-panel="$emit('close')"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import CompDetail from '../comps-details/CompDetail.vue';

export default {
    name: 'ReatlasDetailPanel',

    components: {
        CompDetail
    },
    props: {
        selectedSite: {
            type: Object,
            default: () => ({})
        },
        selectedComp: {
            type: Object,
            default: () => ({})
        },
        layout: {
            type: String,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapState(['projects']),

        isOpen() {
            return this.loading ||
                   Object.keys(this.selectedSite).length > 0 || 
                   (this.layout === 'projects' && Object.keys(this.selectedComp).length > 0);
        },

        projectData() {
            return this.projects.selectedProject;
        }
    }
}
</script>
